import { ReporterSections } from './constants';
import {
  dispatchUpdateReportEvent,
  dispatchUpdateStateEvent
} from '../../events/dispatch';

const { ECDN11, General } = ReporterSections;

export default function updateReporterWithContent(content) {
  const { items } = content;
  const { id, title } = (items && items[0]) || {};
  const stateEvent = { reporter: {} };
  let updateState = false;

  if (id) {
    dispatchUpdateReportEvent({ section: ECDN11, value: { content: id } });
  }
  if (title) {
    updateState = true;
    stateEvent.reporter.title = title;
    dispatchUpdateReportEvent({ section: General, value: { title } });
  }
  if (updateState) {
    dispatchUpdateStateEvent(stateEvent);
  }
}
